<template>
  <div class="topVert" id="reseauxTempo"
       v-if="detailReseauxTempoFilter.length">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold">Proposition réseau(x) temporaire(s)</h2>
    </div>
    <div class="colomn"
      v-for="(reseauxTempo, index) in detailReseauxTempoFilter"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxTempo.libelle}}
      </h3>
      <app-carte-reseaux-tempo :detailReseauxTempo="reseauxTempo"
       :markerReseauxTempo="markerReseauxTempo"/>
      <app-info-reseaux-tempo :infoReseauxTempo="reseauxTempo" :idOpportunite="idOpportunite"
                              :showDimension="showDimension"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import carteReseauxTempo from './carteReseauxTempo';
import infoReseauxTempo from './infoReseauxTempo';

export default {
  name: 'index',
  props: ['detailReseauxTempo', 'adresseReseauxTempo', 'idOpportunite', 'showDimension'],
  components: {
    appCarteReseauxTempo: carteReseauxTempo,
    appInfoReseauxTempo: infoReseauxTempo,
  },
  data() {
    return {
      markerReseauxTempo: {},
    };
  },
  computed: {
    ...mapGetters(['getMaSelection']),
    detailReseauxTempoFilter() {
      const data = this.detailReseauxTempo.filter(d =>
        !d.extensionOpportunite.reseauPersoGuid);
      if (this.getMaSelection) {
        return data.filter(el => el.select);
      }
      return data;
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseReseauxTempo.lat !== undefined) {
        this.markerReseauxTempo = {
          ...this.adresseReseauxTempo,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    // this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxTempo/index.vue